export enum FileUploadError {
    General = 'Er ging iets mis.',
    InvalidFormat = 'Geen correct formaat.'
  }
  